import { RetailerHelpRequest } from "types";
import { apiClient } from "../client";

export const sendRetailerHelpRequest = async ({
  retailer_id,
  ...helpRequest
}: RetailerHelpRequest) => {
  await apiClient.post(`v1/retailers/${retailer_id}/help`, helpRequest);
};
